import { useQuery } from 'react-query';
import { Components } from '../../global.d';
import BadgeService from '../../services/BadgeService';
import { DEALER_BADGES } from '../constants/queryDefinition';

const badgeService = BadgeService.get();

const useBadgeList = (dealerId?: number): Components.Schemas.Badge[] => {
  async function getBadgesForDealer() {
    const response = await badgeService.getBadgesByDealerId(dealerId);

    return response;
  }

  const badges = useQuery(
    `${DEALER_BADGES.KEY}-${dealerId}`,
    getBadgesForDealer,
    {
      enabled: !!dealerId,
      staleTime: DEALER_BADGES.STALE_TIME,
      cacheTime: DEALER_BADGES.STALE_TIME,
      placeholderData: DEALER_BADGES.DEFAULT_RESPONSE
    }
  );

  return (badges?.data instanceof Array
    ? badges?.data
    : DEALER_BADGES.DEFAULT_RESPONSE) as Components.Schemas.Badge[];
};

export default useBadgeList;
